
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";

const HowItWorks = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center mb-8 text-primary animate-fade-in">
            How It Works
          </h1>
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
            Our streamlined process makes implementing AI solutions simple and efficient.
          </p>
          
          <div className="max-w-4xl mx-auto space-y-12">
            {[
              {
                step: 1,
                title: "Choose Your Agent",
                description: "Select from our range of specialized AI agents designed to meet your specific needs.",
                icon: "🤖"
              },
              {
                step: 2,
                title: "Configure & Customize",
                description: "Tailor your agent's settings and parameters to align with your business requirements.",
                icon: "⚙️"
              },
              {
                step: 3,
                title: "Deploy & Monitor",
                description: "Launch your AI agent and track its performance through our intuitive dashboard.",
                icon: "📊"
              }
            ].map((step, index) => (
              <div 
                key={step.title}
                className="flex flex-col md:flex-row items-center gap-8 p-8 bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-accent"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center text-4xl bg-primary/5 rounded-full">
                  {step.icon}
                </div>
                <div className="flex-1 text-center md:text-left">
                  <div className="text-sm text-primary font-semibold mb-1">Step {step.step}</div>
                  <h3 className="text-2xl font-semibold mb-4 text-primary">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 text-center">
            <h2 className="text-3xl font-bold mb-8 text-primary">Ready to Get Started?</h2>
            <button 
              onClick={() => window.location.href = 'https://forms.gle/qQLw9WTSNqFkdt8E9'}
              className="bg-primary text-white px-8 py-3 rounded-lg hover:bg-primary/90 transition-colors duration-300"
            >
              Start Your Journey
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorks;
